import { Component, Input, OnInit } from '@angular/core';
import { PrIconComponent } from '../pr-icon/pr-icon.component';

@Component({
    selector: 'pr-tooltip-icon',
    templateUrl: './pr-tooltip-icon.component.html',
    styleUrls: ['./pr-tooltip-icon.component.scss'],
    standalone: false
})
export class PrTooltipIconComponent extends PrIconComponent implements OnInit {
  @Input() tooltip;
  @Input() tooltipIcon;
  @Input() d;
  @Input() width = 18;

  constructor() {
    super();
    this.viewBoxWidth = 18;
    this.viewBoxHeight = 18;
  }

  ngOnInit() {}
}
